// extracted by mini-css-extract-plugin
module.exports = {"ratingContainer":"pT","hidden":"pU"};